export const getIconURLFromCurrency = (currency, size = 84) => {
  if (currency) {
    if (currency.toLowerCase() === "usd") {
      return "../icon_dollar.svg";
    }

    return `https://media.wazirx.com/media/${currency}/${size}.png`;
  }
  return null;
};

/**
 * Returns a number in Indian numbering system as a String
 *
 * @param {Number/String} number The integer to be converted.
 * @param {Number} decimals The number of digits needed after decimal point.
 * @return {String} Converted number as a String in Indian numbering unit.
 */

export const changeNumberFormatToIndianCurrency = (number, decimals) => {
  const decimalPoints = decimals || 2;
  const noOfThousands = number / 1000;
  const noOfLakhs = number / 100000;
  let displayStr;
  let isPlural;

  // Rounds off digits to decimalPoints decimal places
  function roundOf(integer) {
    return integer.toLocaleString(undefined, {
      minimumFractionDigits: decimalPoints,
      maximumFractionDigits: decimalPoints,
    });
  }

  if (noOfThousands >= 1 && noOfThousands <= 99) {
    const thousands = roundOf(noOfThousands);
    isPlural = thousands > 1;
    displayStr = `${thousands} K`;
  } else if (noOfLakhs >= 1 && noOfLakhs <= 99) {
    const lakhs = roundOf(noOfLakhs);
    isPlural = lakhs > 1;
    displayStr = `${lakhs} L`;
  } else if (noOfLakhs >= 100) {
    const crores = roundOf(noOfLakhs / 100);
    const crorePrefix =
      crores >= 100000 ? changeNumberFormat(crores, decimals, true) : crores;
    isPlural = crores > 1;
    displayStr = `${crorePrefix} Cr`;
  } else {
    displayStr = roundOf(number);
  }

  return displayStr;
};
